"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetMissingAttributes = exports.buildAttributeFilter = void 0;
const react_1 = require("react");
const graphql_1 = require("../../../../__generated__/graphql");
const ramda_1 = require("ramda");
const use_get_strategy_attributes_hook_1 = require("./use-get-strategy-attributes.hook");
const models_1 = require("../../../models");
const buildAttributeFilter = (excludeNodeIds, searchString) => {
    const normalizedSearch = (searchString === null || searchString === void 0 ? void 0 : searchString.trim()) || undefined;
    if (!excludeNodeIds.length && !normalizedSearch) {
        return undefined;
    }
    const filter = {};
    if (excludeNodeIds.length) {
        filter.none = {
            sourceNodeIds: { hasSome: excludeNodeIds },
        };
    }
    if (normalizedSearch) {
        filter.some = Object.assign(Object.assign({}, filter.some), { label: { contains: normalizedSearch, mode: graphql_1.StringFilterMode.Insensitive } });
    }
    return filter;
};
exports.buildAttributeFilter = buildAttributeFilter;
const useGetMissingAttributes = ({ productTreeRootNodeId, productTreeNodeId, options }) => {
    const skip = !productTreeRootNodeId || !productTreeNodeId || (options === null || options === void 0 ? void 0 : options.skip);
    const excludeFilter = (0, react_1.useMemo)(() => (0, exports.buildAttributeFilter)([productTreeNodeId]), [productTreeNodeId]);
    const { data: attributesData, previousData: previousAttributesData, isLoading: attributesLoading, error: attributesError, pagination: { isLoadingMore: attributesMoreItemsLoading, onNextPage, hasNextPage, }, refetch, } = (0, use_get_strategy_attributes_hook_1.useGetStrategyAttributes)({
        productTreeNodeId: productTreeRootNodeId,
        sortingItem: models_1.SortingItem.SortByTextAsc,
        options: { skip },
        filter: excludeFilter,
    });
    const data = attributesLoading && (!attributesData || (0, ramda_1.isEmpty)(attributesData)) ? previousAttributesData : attributesData;
    const attributeOptionList = (0, react_1.useMemo)(() => {
        if (!data)
            return [];
        return data.map(({ node: { label, description } }) => ({ label, value: label, description }));
    }, [data]);
    const onRefetch = (0, react_1.useCallback)((searchString) => refetch({
        filter: (0, exports.buildAttributeFilter)([productTreeNodeId], searchString),
    }), [refetch, productTreeNodeId]);
    return {
        attributeOptionList,
        hasNextPage,
        loading: attributesLoading && !data,
        isSearching: attributesLoading,
        moreItemsLoading: attributesMoreItemsLoading,
        error: attributesError,
        fetchMore: onNextPage,
        refetch: onRefetch,
    };
};
exports.useGetMissingAttributes = useGetMissingAttributes;
